import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import VTooltip from "v-tooltip";
//import Vuetify from "vuetify";
//import "vuetify/dist/vuetify.min.css";

//Vue.use(Vuetify);
Vue.use(VTooltip);


Vue.config.productionTip = false

router.beforeEach((to,from,next)=>{
  let language = to.params.lang
  if(!language){
    language = 'FR'
  }

  i18n.locale = language
  next()
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
